import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { MdOutlineBackup } from "react-icons/md";
import Spinner from "../../../../Components/Spinner";
import ErrorMessage from "../../../../Components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";
import SwitchToggle from "../../../PlatformComponents/SwitchToggle";
import { BsGear } from "react-icons/bs";
import { VscLock } from "react-icons/vsc";

const DbSettingsModal = ({ show, handleClose, settings, fetchRecords }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });

    const [backup, setBackup] = useState(false);
    const [autoscale, setAutoscale] = useState(false);
    const [initialSettings, setInitialSettings] = useState(null);

    useEffect(() => {
        if (show && settings) {
            setBackup(settings.backup);
            setAutoscale(settings.autoscale);
            setInitialSettings({ ...settings });
        }
    }, [show, settings]);

    const isChanged =
        initialSettings &&
        (backup !== initialSettings.backup || autoscale !== initialSettings.autoscale);

    const handleSave = async () => {
        setLoading(true);
        const data = {
            user_id,
            db_id,
            settings: {
                backup,
                autoscale,
            },
        };

        try {
            const response = await fetch("https://backend.erioon.com/update_db_settings", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            setLoading(false);

            if (response.ok) {
                setError({ message: "", display: false });
                fetchRecords();
                handleClose();
            } else {
                const errText = await response.text();
                setError({ message: errText || "Failed to update settings", display: true });
            }
        } catch (error) {
            setLoading(false);
            setError({ message: "Network error while saving settings", display: true });
        }
    };

    const closeModal = () => {
        handleClose();
        setError({ message: "", display: false });
    };

    return (
        <Modal show={show} onHide={closeModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label"><BsGear /> Database settings</p>

                <div className="warning_delete_message">
                    <p>Backup saves your data in real time, while Autoscale automatically adjusts resources when your database reaches its maximum capacity.</p>
                    <p>Learn more in our <strong>documentation</strong>.</p>
                </div>

                <div className="backup_body">
                    {/* <div className="backup_body_row">
                        <label>Backup sync</label>
                        <SwitchToggle status={backup} onToggle={() => setBackup(prev => !prev)} />
                    </div> */}
                    <div className="backup_body_row">
                        <label>Autoscale <VscLock/></label>
                        <SwitchToggle status={autoscale} onToggle={() => setAutoscale(prev => !prev)} />
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    {/* <button
                        className={`save_btn ${!isChanged ? "disabled" : ""}`}
                        onClick={handleSave}
                        disabled={!isChanged || loading}
                    >
                        {loading ? <Spinner loading={loading} /> : t.save}
                    </button> */}
                    <button className="cancel_btn" onClick={closeModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DbSettingsModal;
